export default __webpack_public_path__ + "static/media/amex.b9b4f409.svg";